// extracted by mini-css-extract-plugin
export default {"root":"ProvidentCloudHeader_root__RYGzj","logo":"ProvidentCloudHeader_logo__UwJ8M","data":"ProvidentCloudHeader_data__LPQup"};